import LegalLayout from "./LegalLayout";

const CommunityGuidelines = () => (
  <LegalLayout title="Community Guidelines" lastUpdated="May 8, 2026">
    <p>
      DHDH is a private, verified-only space for Canadian Registered Dental Hygienists. The
      strength of this community depends on every member showing up with respect, honesty, and
      professionalism. By joining, you agree to follow these guidelines.
    </p>

    <h2>1. Be respectful</h2>
    <ul>
      <li>Treat every member the way you'd want to be treated by a colleague.</li>
      <li>Disagreement is welcome — personal attacks, slurs, harassment, and discrimination are not.</li>
      <li>No bullying, intimidation, or "pile-ons" on individual members or specific clinics.</li>
    </ul>

    <h2>2. Protect patient privacy</h2>
    <ul>
      <li>Never share identifying information about patients (name, photo, chart, location, scheduling details).</li>
      <li>Generic clinical scenarios are fine; named cases are not.</li>
      <li>If you need help with a specific clinical question, anonymize the details before posting.</li>
    </ul>

    <h2>3. Stay within scope of practice</h2>
    <p>
      DHDH discussions are peer-to-peer. They do not constitute formal medical, legal, or
      professional advice. Always defer to your provincial regulator's standards of practice and
      to your own clinical judgement.
    </p>

    <h2>4. Be honest</h2>
    <ul>
      <li>One real account per person. No impersonation, no duplicate accounts.</li>
      <li>Don't post fake reviews of clinics or fake wage data — it harms other members making real decisions.</li>
      <li>If you're a vendor, recruiter, or non-RDH professional, do not register for a member account. Use the partner application form instead.</li>
    </ul>

    <h2>5. Keep it confidential</h2>
    <ul>
      <li>What's posted here stays here. Do not screenshot, screen-record, or share content from DHDH outside the platform without the original poster's consent.</li>
      <li>Sensitive pages display an invisible watermark with the viewing member's name and email so redistributed copies can be traced back to the source.</li>
      <li>Anonymous wage data is for member context only — not for redistribution.</li>
    </ul>

    <h2>6. No promotion or solicitation without permission</h2>
    <ul>
      <li>Don't promote your own products, services, courses, or affiliate links unprompted.</li>
      <li>Job postings go in the official Jobs board, not in discussions or DMs.</li>
      <li>Mentorship is welcome; charging fellow members for casual peer support is not.</li>
    </ul>

    <h2>7. Use clinic and employer reviews fairly</h2>
    <ul>
      <li>Reviews must reflect your own first-hand experience.</li>
      <li>Stick to facts: working conditions, scheduling practices, pay structure, professional culture.</li>
      <li>No defamation, no naming individual coworkers, no allegations of crimes you can't substantiate. We may remove reviews that cross these lines.</li>
    </ul>

    <h2>8. Anonymous posts are still accountable</h2>
    <p>
      You can post discussions anonymously. Your identity is hidden from other members but visible
      to admins for moderation. Anonymous posts must still follow every rule above.
    </p>

    <h2>9. Reporting</h2>
    <p>
      If you see content that violates these guidelines, use the Report flag on the post or
      message admins directly. We review every report within 72 hours.
    </p>

    <h2>10. Consequences</h2>
    <ul>
      <li><strong>First minor violation:</strong> a private warning + content removal.</li>
      <li><strong>Repeated or serious violations:</strong> temporary suspension.</li>
      <li><strong>Severe violations</strong> (harassment, doxxing, patient privacy breach, fraud): immediate permanent ban with no refund.</li>
    </ul>

    <p className="mt-8">
      We exist because the dental hygiene profession deserves a community of its own. Help us
      keep it safe, honest, and useful for every RDH across Canada. Thank you.
    </p>
  </LegalLayout>
);

export default CommunityGuidelines;
